import { useState, useCallback, useRef } from "react";
import * as XLSX from "xlsx";
import { useChatContext } from "../../../contexts/ChatContext";
import styles from "./PromptsLibrary.module.scss";
import SendPromptSuggModal from "./SendPromptSuggModal";
import { chatInputConfig } from "../../../config/componentsConfig";
import Fuse from "fuse.js";
import { useMemo } from "react";
import { Accordion } from "react-bootstrap";

interface PromptsLibraryProps {
  selectedMode: string;
  filters: any;
  page: string;
  promptLibraryData: any[];
}

const Prompt = ({prompt, onClick}: {prompt: any, onClick: (prompt: string, mode: string) => void}) => {
  const [isHovering, setIsHovering] = useState(false);
  return (
    <div className={styles.lineStyleAnswer} onMouseEnter={() => setIsHovering(true)} onMouseLeave={() => setIsHovering(false)}>
      <div key={"mode"} className={styles.modeStyle} style={isHovering ? {color: "#00afcd", border: "1px solid #00afcd"} : {}}>
          <i className={chatInputConfig.optionIcons[prompt.Mode].icon} />
          {chatInputConfig.optionIcons[prompt.Mode].label}
      </div>
      <div key={"prompt"} className={styles.speechBubble} onClick={() => onClick(prompt.Prompt, prompt.Mode)}>
        {isHovering && <div className={styles.notification}>TRY</div>}
        {prompt.Prompt}
      </div>
    </div>
  )
}

const PromptLibraryRow = ({theme, prompts, onClick}: {theme: string, prompts: any[], onClick: () => void}) => {

  if(!prompts || prompts.length === 0) {
    return null;
  }
  
  /*return (
    <>
      {theme && <div className={styles.lineStyle}>
          <div key={"theme"} className={styles.themeStyle}>
            {theme}
          </div>
      </div>}
      <div className={styles.lineStyleAnswer} style={!theme ? {border: "none", marginTop: 0} : {marginTop: 10}} onMouseEnter={() => setIsHovering(true)} onMouseLeave={() => setIsHovering(false)}>
          <div key={"mode"} className={styles.modeStyle} style={isHovering ? {color: "#00afcd", border: "1px solid #00afcd"} : {}}>
              <i className={chatInputConfig.optionIcons[mode].icon} />
              {chatInputConfig.optionIcons[mode].label}
          </div>
          <div key={"prompt"} className={styles.speechBubble} onClick={onClick}>
            {isHovering && <div className={styles.notification}>TRY</div>}
            {prompt}
          </div>
      </div>
    </>)*/
     return (
      <Accordion.Item eventKey={theme}>
        <Accordion.Header>{theme}</Accordion.Header>
        <Accordion.Body>
          {prompts.map((prompt, index) => (
            <Prompt 
              key={index} 
              prompt={prompt} 
              onClick={onClick}
            />
          ))}
        </Accordion.Body>
      </Accordion.Item>)
} 

const PromptsLibrary = ({ selectedMode, filters, page, promptLibraryData }: PromptsLibraryProps) => {
  const {sendQuery} = useChatContext();
  const filtersRef = useRef(filters);
  const [showSendPromptSuggModal, setShowSendPromptSuggModal] = useState(false);
  const [query, setQuery] = useState("");
  //const [data, setData] = useState([]);

  const handleFileUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file) return;

    const reader = new FileReader();
    reader.readAsBinaryString(file);

    reader.onload = (e) => {
      const binaryStr = e.target?.result;
      const workbook = XLSX.read(binaryStr, { type: "binary" });

      // Read the first sheet
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];

      // Convert sheet to JSON
      const jsonData = XLSX.utils.sheet_to_json(sheet);
      setData(jsonData);
    };
  };

  const handleQuery = useCallback((input: string, mode: string) => {
    if (input?.trim()) {
      const payload = {
        query: input,
        filters: filtersRef.current,
        question_type: mode,
        is_reformulated: false,
        page: page
      };
      
      // Debug uniquement : ne pas utiliser `console.error` pour éviter
      // une fausse impression d'erreur côté console.
      console.log('Sending query with payload:', payload);
      sendQuery(payload);
    }
  }, [selectedMode, sendQuery, page]);

  const filterLibraryOnModeAndPage = (data: any[]) => {
    return data.filter((row) => {
      if (row.Agent) {
        return row.Agent === page && row.Mode === selectedMode;
      }
      return row.Mode === selectedMode;
    });
  };

  /*const fuse = new Fuse(filterLibraryOnModeAndPage(promptLibraryData), {
    keys: ["Theme", "Mode", "Prompt"],
    threshold: 0.5, // Lower = stricter match, Higher = more fuzzy
  });

  const results = query ? fuse.search(query).map((result) => result.item) : data; //filterLibraryOnModeAndPage(promptLibraryData);
  */

  const groupbyTheme = (data: any[]) => {
    return Object.values(data.reduce((acc, row) => {
      if (!acc[row.Theme]) {
        acc[row.Theme] = { Theme: row.Theme, Prompts: [] };
      }
      acc[row.Theme].Prompts.push(row);
      return acc;
    }, {}));
  }

  const uniqueCategories = [...new Set(promptLibraryData.map(item => item.Category))];

  return (
    <div style={{padding: 20, overflowY: "hidden", height: "100%", width: "100%", position: "relative"}}>
        {/*<input type="file" accept=".xlsx" onChange={handleFileUpload} />*/}
        <div className={styles.suggestionLinkStyle} onClick={() => setShowSendPromptSuggModal(true)}>
            <i className="bi bi-send"></i>
            Suggest a prompt or a modification
        </div>
        {/*<input
            type="text"
            className={styles.searchInput}
            autoComplete="off"
            placeholder="Search..."
            value={query}
            onChange={(e) => setQuery(e.target.value)}
        />*/}
        {filterLibraryOnModeAndPage(promptLibraryData).length > 0 && (
        <div className="mt-4" style={{overflow: "auto", height: "100%", padding: 20}}>
          {uniqueCategories.map((category) => (
            <>
            <h5 style={{marginBottom: 10, marginTop: 20}}>{category}</h5>
            <Accordion>
              {groupbyTheme(promptLibraryData.filter((row) => row.Category === category)).map((row, index) => {
                  return (
                  <PromptLibraryRow 
                      key={index} 
                      theme={row.Theme} 
                      prompts={row.Prompts}
                      onClick={handleQuery}
                  />
                  )
              })}
            </Accordion>
            </>
          ))}
          
          <div style={{height: 100}}></div>
        </div>
      )}
      <SendPromptSuggModal 
        show={showSendPromptSuggModal} 
        handleClose={() => setShowSendPromptSuggModal(false)}
      />
    </div>
  );
};

export default PromptsLibrary;
